import { actions, actionTypes } from './reducer'
import type { AppDispatch } from '~publish/legacy/store'
import americanEnglishTranslations from './translations/en-us.json'
import spanishSpainTranslations from './translations/es-es.json'
import chinaChineseTranslations from './translations/zh-cn.json'

type I18nAction = {
  type: string
  locale: string
}

type Next = (action: I18nAction) => unknown

const middleware =
  (store: { dispatch: AppDispatch }) =>
  (next: Next) =>
  (action: I18nAction): unknown => {
    switch (action.type) {
      case actionTypes.SET_LOCALE:
        switch (action.locale) {
          case 'en-US':
            store.dispatch(
              actions.setTranslations({
                translations: americanEnglishTranslations,
              }),
            )
            break
          case 'zh-CN':
            store.dispatch(
              actions.setTranslations({
                translations: chinaChineseTranslations,
              }),
            )
            break
          case 'es-ES':
            store.dispatch(
              actions.setTranslations({
                translations: spanishSpainTranslations,
              }),
            )
            break
          default:
            // default to american english translations
            store.dispatch(
              actions.setTranslations({
                translations: americanEnglishTranslations,
              }),
            )
            break
        }
        break
      default:
        break
    }
    return next(action)
  }

export default middleware
